import React from "react";
import { Box, Container, Paper, Typography } from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import { DefaultLayout } from "../DefaultLayout";
import { getTheme } from "../../common/getLocalTheme";

export const FailedProjectManagement = () => {
  return (
    <Container>
      <Typography variant="h4">Custom Reports</Typography>
      <Box padding={2}>
        <Paper>
          <Box padding={2}>
            <MuiLink
              component={Link}
              to={"/project_management/custom_reports/reports"}>

              <Typography variant="h6">Failure Reports</Typography>
            </MuiLink>

            <MuiLink
              component={Link}
              to={"/project_management/custom_reports/Retest_reports"}>

              <Typography variant="h6">Retest Required Reports</Typography>
            </MuiLink>

            <MuiLink
              component={Link}
              to={"/project_management/custom_reports/flash_reports_correction"}>

              <Typography variant="h6">Flash Reports Correction</Typography>
            </MuiLink>

            <MuiLink
              component={Link}
              to={"/project_management/custom_reports/flash_reports"}>

              <Typography variant="h6">Flash Reports</Typography>
            </MuiLink>
            {
              !getTheme() &&
              <MuiLink
                component={Link}
                to={"/project_management/custom_reports/report_builder"}>

                <Typography variant="h6">Report Builder</Typography>
              </MuiLink>}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};


// UVID and FE Fuctiontion converted into flash report and flash report is changed into flash report correction